export default __webpack_public_path__ + "img/search.49b154e5.svg";